import { el, clear } from "../dom.js";
import type { ResultReaction } from "../../engine/recommend.js";

const CHOICES: { value: ResultReaction; label: string }[] = [
  { value: "fits", label: "This fits" },
  { value: "partial", label: "It partly fits" },
  { value: "not", label: "It doesn't fit" },
  { value: "need_more", label: "I need more information" },
];

export function renderReaction(container: HTMLElement, onReact: (reaction: ResultReaction) => void): void {
  clear(container);
  const buttons = CHOICES.map((choice) =>
    el("button", { className: "option", type: "button", "data-value": choice.value }, [choice.label]),
  );
  const screen = el("section", { className: "screen" }, [
    el("span", { className: "eyebrow" }, ["Your reaction"]),
    el("h1", {}, ["What do you make of it?"]),
    el("p", {}, [
      "Your answer is recorded as feedback. It does not recalculate anything, and it cannot override the result you already saw.",
    ]),
    el("div", { className: "reaction-grid" }, buttons),
  ]);
  for (const button of buttons) {
    button.addEventListener("click", () => {
      const value = button.dataset["value"] as ResultReaction;
      onReact(value);
    });
  }
  container.append(screen);
}
